export default "__VITE_ASSET__CUQqm9VD__"